module.exports = __webpack_public_path__ + "static/media/no-thank-you-addon-option.54f16579.jpg";